import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { GeneralFieldsBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";
import { ContentProp } from "@/react/components/shared/BuilderUI/constants/PropCategories";

export const meta: ComponentMeta = {
  name: "Link",
  version: 1,
  nameI18n: "builder_ui.block_type.form_link",
  category: [GeneralFieldsBlock],
  props: {
    label: {
      prop: "other",
      type: "string",
      name: "Label",
      nameI18n: "builder_ui.prop_type.label",
      category: [ContentProp],
    },
    placeholder: {
      prop: "other",
      type: "string",
      name: "Placeholder",
      nameI18n: "builder_ui.prop_type.url_placeholder",
      category: [ContentProp],
    },
    required: {
      prop: "other",
      type: "boolean",
      name: "Required",
      nameI18n: "builder_ui.prop_type.required",
      category: [ContentProp],
    },
  },
};
